import React from 'react';
import { Icon } from 'hfs-common-ui';
import { Trans } from 'react-i18next';
import { InternationalizationNameSpace as Ns } from '~/constants/internationalization-namespace';
import FailedMowersListModal from '~/domain/inventory-list/components/BatchControlButtonsResultIndication/FailedMowersListModal';
import MobileInfoModal from './MobileInfoModal';
import * as S from './styled';

export interface Props {
  title: string;
  iconType?: string;
  iconColor?: string;
  message: string;
  dismissCallback: () => void;
  failedIprIds?: string[];
}

export const MobileOperationResultIndicatorModal = ({
  iconColor,
  iconType,
  title,
  message,
  failedIprIds,
  dismissCallback,
}: Props) => {
  if (failedIprIds !== undefined && failedIprIds.length > 0) {
    return (
      <FailedMowersListModal
        failedIprIds={failedIprIds}
        totalCount={failedIprIds.length}
        dismissCallback={dismissCallback}
        header={
          <S.ControlButtonCommandErrorTitleDiv>
            {iconType !== undefined && <Icon type={iconType} color={iconColor} />}
            <span>{title}</span>
          </S.ControlButtonCommandErrorTitleDiv>
        }
        message={message}
        dismissButtonContent={<Trans i18nKey="ok_button" ns={Ns.Common} />}
      />
    );
  }

  return (
    <MobileInfoModal
      message={message}
      title={title}
      iconType={iconType}
      iconColor={iconColor}
      dismissCallback={dismissCallback}
    />
  );
};

export default MobileOperationResultIndicatorModal;
